import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../hooks/useTheme";
import React from "react";

export const ThemeToggle: React.FC = React.memo(() => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-gray-600 bg-gray-800 hover:bg-gray-700 transition-colors text-sm text-white dark:text-inherit"
    >
      {theme === "dark" ? (
        <Sun className="w-4 h-4 text-yellow-400" />
      ) : (
        <Moon className="w-4 h-4 text-indigo-400" />
      )}
      {theme === "dark" ? "Light" : "Dark"}
    </button>
  );
});
